import { render, staticRenderFns } from "./ComboboxByProject.vue?vue&type=template&id=95e70d9e"
import script from "./ComboboxByProject.vue?vue&type=script&lang=js"
export * from "./ComboboxByProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports